<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-card-title>Mark Active/In-Active Students</v-card-title>
            <v-row>
                <v-col sm="3" md="3"></v-col>
                <v-col sm="6" md="6">
                    <v-autocomplete :items="stud_list" item-value="lid" v-model="stud_data" item-text="name"
                        label="Search Student" dense rounded outlined :loading="comp_load"
                        placeholder="Search by PRN No or name" color="#0F2027" multiple clearable></v-autocomplete>
                </v-col>
                <v-col sm="3" md="3"></v-col>
            </v-row>
            <!-- {{ child_data }} -->
            <v-row v-if="stud_data">
                <v-col sm="3" md="3"></v-col>

                <v-col md="4" sm="4">
                    <v-select rounded :items="status_list" label="Change Status" item-text="name" item-value="value"
                        outlined dense v-model="cur_status"></v-select>
                </v-col>
            </v-row>
            <v-row v-if="stud_data">
                <v-col sm="3" md="3"></v-col>
                <v-col v-if="cur_status != 0" md="6" sm="6">
                    <v-text-field persistent-hint hint="Remark for in-active(if any)" dense type="text"
                        v-model="status_reason"></v-text-field>
                </v-col>
            </v-row>
            <v-row v-if="stud_data">
                <v-col sm="3" md="3"></v-col>
                <v-col md="6" sm="6">
                    <v-checkbox dense v-model="isloginblocked" color="success"
                        label="Would you like to block the login ?"></v-checkbox>
                </v-col>
            </v-row>
            <v-row v-if="stud_data">
                <v-col sm="3" md="3"></v-col>
                <v-col md="3" sm="3">
                    <v-btn color="warning" @click="toggle">Save Status</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box">
            <v-card-title>Get Active/In-Active Student List</v-card-title>
            <v-row>
                <v-col sm="3" md="3"></v-col>
                <v-col sm="6" md="6">
                    <v-autocomplete :items="status_list" item-value="value" v-model="sel_status" item-text="name"
                        label="Select Status" dense rounded outlined :loading="comp_load" color="#0F2027"
                        @change="getStudStatusList()"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <!-- <v-col sm="3" md="3"></v-col> -->
                <!-- <v-col cols="12" sm="12" md="12"> -->
                <!-- <v-data-table v-if="stud_status_list.length > 0" :headers="headers" :items="stud_status_list" :search="search" class="mytable">
                      <template v-slot:top>
                          <v-toolbar flat class="toolbar">
                              <v-toolbar-title>Student List</v-toolbar-title>
                              <v-divider class="mx-4" inset vertical></v-divider>
                              <v-spacer></v-spacer>
                              <v-text-field v-model="search" append-icon="search" label="Search" background-color="white" single-line hide-details></v-text-field>
                          </v-toolbar>
                      </template>
</v-data-table> -->
                <v-col cols="12" sm="6" md="6" v-if="stud_status_list != ''">
                    <v-text-field class="ma-2 no-display" v-model="search" append-icon="mdi-magnify"
                        label="Search by Student name or by Registration Number" single-line
                        hide-details></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="4" md="4" v-if="stud_status_list != ''" align="right">
                    <v-btn class="ma-2 no-display" rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'Student Status List')" :loading="loader"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>
                <v-simple-table v-if="stud_status_list != ''" dense class="elevation-1 ma-3" style="width:100%"
                    id="my-table-id" fixed-header>
                    <thead>
                        <tr>
                            <th class="">Sr. No.</th>
                            <th class="">Registration No.</th>
                            <th class="">Name</th>
                            <th class="">Remark</th>
                            <th class="" v-for="header in component_headers" :key="header">
                                <center>{{ header }}</center>
                            </th>
                            <th>Active / Inactive Date</th>
                            <th>Status Changed By</th>
                        </tr>
                    </thead>
                    <tbody style="overflow-y: scroll;">
                        <tr v-for="s, index in filteredItems" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ s.reg_no }}</td>
                            <td>{{ s.name }}</td>
                            <td>{{ s.inactive_reason }}</td>
                            <td v-for="(header, index) in s.all_comp" :key="index">
                                <span v-if="header == 'Not Applicable'" class="text-color">
                                    {{ header }}
                                </span>
                                <span v-else>
                                    {{ header }}
                                </span>
                            </td>
                            <td>{{ s.gen_date }}</td>
                            <td>{{s.status_changed_by}}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
                <!-- </v-col> -->
            </v-row>
            <!-- {{ stud_status_list }}
      Coming soon -->
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

    data: () => ({
        comp_load: false,
        stud_list: null,
        // extraBreadcrumbItems: [


        // ],
        breadcrumbClass: "breadcrumb-style1",
        stud_data: "",
        child_data: "",
        status_reason: "",
        isloginblocked: false,
        search: "",
        snackbar_msg: "",
        snackbar: false,
        color: "",
        cay: null,
        cur_status: "",
        status_list: [],
        sel_status: null,
        stud_status_list: [],
        component_headers: [],
        headers: [
            {
                text: "Registration No.",
                value: "reg_no",
                align: "center",
            },
            {
                text: "Student name",
                value: "name",
                align: "center",
            },
            {
                text: "Remark",
                value: "inactive_reason",
                align: "center",
            },
        ],
    }),
    mounted() {
        this.onload();
    },
    computed: {
        filteredItems() {
            return this.stud_status_list.filter((item) => {
                return item.name.toLowerCase().indexOf(this.search.toLowerCase()) > -1 || item.reg_no.toLowerCase().indexOf(this.search.toLowerCase()) > -1;
            });
        },
    },
    methods: {
        fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table style='border-collapse:collapse;' border='1'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                exportTable.find(".v-toolbar").remove();
                exportTable.find('th, td').each(function() {
                    $(this).css('border', '1px solid black');
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                const filename = name+'.xls';

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // For IE
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else {
                    // For modern browsers
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = filename;
                    a.click();
                    window.URL.revokeObjectURL(url);
                }
        },
        async getStudStatusList() {
            this.stud_status_list = []
            this.component_headers = []
            const data = {
                sel_status: this.sel_status,
            };
            try {
                this.comp_load = true;
                const res = await axios.post("/admission/getStudStatusList", data);
                if (res.data.flag == "YES") {
                    // this.showSnackbar("success", "Success");
                    this.stud_status_list = res.data.stud_list;
                    this.component_headers = res.data.header_list;
                }
            } catch (error) {
                this.showSnackbar("error", "Something went wrong..."); // show snackbar
            } finally {
                this.comp_load = false;
            }
        },
        onload() {
            this.comp_load = true;
            axios
                .post("/admission/getAllStudents1")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.stud_list = res.data.stud_list;
                        this.status_list = res.data.status_list;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        toggle() {
            const data = {
                stud_id: this.stud_data,
                status_id: this.cur_status,
                status_reason: this.status_reason,
                isloginblocked: this.isloginblocked,
            };
            axios
                .post("/admission/saveData", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Updated successfully");
                        this.stud_data = null;
                        this.status_reason = null;
                        this.isloginblocked = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                    this.overlay = false;
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        getData(stud_data) {
            alert("stud_data==>" + stud_data);
            const data = {
                stud_data: stud_data,
            };
            axios
                .post("/admission/getChildData", data)
                .then((res) => {
                    if (res.data.status == "SUCCESS") {
                        this.child_data = res.data.child_data;
                        this.cay = res.data.cay;
                    } else {
                        alert("Somthing went wrong!!!");
                    }
                })
                .catch((error) => {
                    alert("Somthing went wrong!!!");
                })
                .finally(() => {
                    this.comp_load = false;
                });
        },
    },
};
</script>
<style scoped>
.text-color {
    font-weight: bold;
    color: red;
    font-size: small;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: center;
    font-size: small;
}

tr,
tbody {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0.3rem !important;
    padding: 0.4rem !important;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

v-simple-table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}
</style>
